export default __webpack_public_path__ + "static/media/digiPage@2x.e1addb93.png";